import React from "react";
import ChineseLanguage from "../../components/ChineseLanguage";
import Footer from "../../components/Footer";
import NavBar from "../../components/navbar/NavBar";

const Chinese = () => {
  return (
    <div>
      <NavBar />
      <ChineseLanguage />
      <Footer />
    </div>
  );
};

export default Chinese;
